var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5538 136.935L20.7744 110.508L80.5538 84.2222L106.84 24.5842L133.126 84.2222L192.905 110.508L133.126 136.935L106.84 196.573L80.5538 136.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.84 57.3711L123.092 94.2562L159.977 110.508L123.092 126.76L106.84 163.645L90.5876 126.76L53.7025 110.508L90.5876 94.2562L106.84 57.3711Z",
    fill: "#F30028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 215.087H513V237.274H0V215.087ZM0 259.462H513V281.649H0V259.462Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/AW.50fbc14c765d2b9a87d2717021c589a3.svg";
export { ForwardRef as ReactComponent };